module.exports = __webpack_public_path__ + "img/noSession.64d17b7a.gif";